import { fetchWrapper, handleResponse, hcUrlV3, buildOpts } from 'services/RequestService/helpers';

export const getMealBadges = async ({ params: { menuSlug } }) => {
  const response = await fetchWrapper(hcUrlV3(`/menus/${menuSlug}/meal_badges`), buildOpts());

  return handleResponse(response);
};
